import { get, patch, post, put } from '@elementary/common-ui/utils/http';
import {
  CreateDigestRuleApi,
  FetchDigestRules,
  UpdateDigestRuleApi,
} from '../types';

export const fetchDigestRules = (envId: string): Promise<FetchDigestRules> =>
  get(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/digest-rules`,
  );

export const createDigestRule = (data: CreateDigestRuleApi, envId: string) =>
  post(
    `${import.meta.env.VITE_API_BASE_URL}/environments/${envId}/digest-rules`,
    data,
  );

export const updateDigestRule = (
  data: UpdateDigestRuleApi,
  envId: string,
  ruleId: string,
) =>
  put(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/digest-rules/${ruleId}`,
    data,
  );

export const deactivateDigestRule = (ruleId: string, envId: string) =>
  patch(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/digest-rules/${ruleId}/deactivate`,
    {},
  );

export const activateDigestRule = (ruleId: string, envId: string) =>
  patch(
    `${
      import.meta.env.VITE_API_BASE_URL
    }/environments/${envId}/digest-rules/${ruleId}/activate`,
    {},
  );
